<div class="login-main-wrapper min-image-handel m-0 p-4">
  <div class="left-side">
    <div class="logo ">
      <img src="assets/images/img/logo-main.png" alt="logo">
    </div>
    <div class="inner-wrapper min-image-handel-card">
      <div class="right-content  p-3 p-lg-0">
        <div class="mb-4">
          <h2 class="fs-32 fw-600 m-0 mb-2">
            Forgot Password?
          </h2>
          <p class="fs-16 fw-400 text-secondary m-0">
            No worries, we’ll send you a temporary password on your registered email.
          </p>
        </div>

        <form (submit)="submit()" [formGroup]="forgotPasswordForm" class="col-12 example-form">

          <div class="col-12 form-group mb-3">
            <div
              [ngClass]="[ (forgotPasswordForm.controls['email'].touched && forgotPasswordForm.controls['email'].invalid) || errorMsg ? 'custom-form  inputContainer' : 'custom-form']"
              class="input-relative">
              <input type="text" class=" w-100" name="email" required formControlName="email" (input)="onEmailInput($event)"/>
              <label for="text" class="label-name fs-14 w-100">
                Email
              </label>
            </div>
            <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
              *ngIf="(forgotPasswordForm.controls['email'].touched && forgotPasswordForm.controls['email'].invalid)">
              {{forgotPasswordForm.controls['email'].errors ? 'Please enter a valid Email' : ''}} </p>

              <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
              *ngIf="errorMsg && !forgotPasswordForm.controls['email'].invalid">
              {{errorMsg}} </p>
          </div>

          <div class="col-12 mt-4">
            <button autofocus button-primary-auth type="submit"
              class="w-100 border-0 mb-3 btn btn-primary fs-18 fw-500">Send Temporary Password</button>
            <button routerLink="/login" class="fw-500 fs-18 btn btn-default w-100">
              Back to Sign In
            </button>
          </div>
        </form>
        <!-- <p class="fs-14 fw-400 m-0 text-center">
          Don’t have an account?
          <span class="fw-500 link-text cursor" [routerLink]="'/register'">Sign up</span>
        </p> -->
      </div>
    </div>
    <div class="align-items-center d-flex flex-wrap justify-content-between terms-condition-wrap gap-2">
      <div class="left">
        <p class="fs-14 fw-300 mb-0">
          ©{{_shared.epoch}} Recuvery LLC. All rights reserved.
        </p>
      </div>
      <div class="right">
        <ul class="d-flex align-items-center gap-2 mb-0 policy--listing">
          <li class="fs-14 fw-400">
            <a href="{{env.websiteUrl}}privacy-policy" target="_blank">Privacy Policy</a>
          </li>
          <li>•</li>
          <li class="fs-14 fw-400">
            <a href="{{env.websiteUrl}}terms-and-conditions" target="_blank"> Terms & Conditions</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="min-image-handel-card left-card-wrapper d-none  p-0">
    <div class="login-left--wrapper">
      <div class="image-div">
        <img class="main-image" src="assets/images/img/main-image.png" alt="login register">
      </div>
      <!-- <img src="assets/images/img/backgound-main.png"> -->
      <div class="bottom-content">
        <div class="left d-flex gap-2 align-items-center">
          <img src="assets/images/img/call-icon.png">
          <p class="mb-0 fw-500 fs-16">Call us at <span>+1 (833) 904-7001</span></p>
        </div>
        <div class="right btn-group gap-3">
          <a class="fw-500 fs-16 btn btn-white" href="https://www.recuvery.com/demo-scheduler/"
          target="_blank">Book a Demo</a>
          <button class="fw-500 fs-16 btn btn-black d-none">
            <img src="assets/images/img/player-play-filled.png">
            <span>Watch Video</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>